export const USER_CUSTOM_FIELD_TYPES = [
  { value: 'text', label: 'Texto' },
  { value: 'textarea', label: 'Textarea' },
  { value: 'number', label: 'Número' },
  { value: 'decimal', label: 'Decimal' },
  { value: 'peso', label: 'Peso chileno' },
  { value: 'email', label: 'Correo' },
  { value: 'url', label: 'URL' },
  { value: 'phone', label: 'Teléfono' },
  { value: 'date', label: 'Fecha' },
  { value: 'datetime', label: 'Fecha y hora' },
  { value: 'checkbox', label: 'Checkbox' },
  { value: 'switch', label: 'Switch' },
  { value: 'radio', label: 'Radio' },
  { value: 'select', label: 'Select' },
  { value: 'multiselect', label: 'Multi Select' },
  { value: 'color', label: 'Color' },
  { value: 'file', label: 'Archivo' },
  { value: 'image', label: 'Imagen' },
] as const;

export type UserCustomFieldType = (typeof USER_CUSTOM_FIELD_TYPES)[number]['value'];

const OPTION_TYPES: UserCustomFieldType[] = ['radio', 'select', 'multiselect'];

export function customFieldInputKind(type: string): UserCustomFieldType {
  return USER_CUSTOM_FIELD_TYPES.some((item) => item.value === type) ? (type as UserCustomFieldType) : 'text';
}

export function fieldTypeHasOptions(type: string): boolean {
  return OPTION_TYPES.includes(type as UserCustomFieldType);
}

export function fieldTypeHasFileUploads(type: string): boolean {
  return type === 'file' || type === 'image';
}

export function fieldTypeLabel(type: string): string {
  return USER_CUSTOM_FIELD_TYPES.find((t) => t.value === type)?.label ?? type;
}

export function slugifyFieldName(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

export function groupIconForName(groupName: string): string {
  const lower = groupName
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  if (lower.includes('comercial') || lower.includes('pago') || lower.includes('caja')) return 'payments';
  if (lower.includes('academ')) return 'school';
  if (lower.includes('personal') || lower === 'general') return 'person';
  if (lower.includes('laboral')) return 'work';
  return 'folder';
}

export function groupDotClass(groupId?: string | null): string {
  if (!groupId) return 'bg-secondary-300';
  const n = groupId.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return n % 2 === 0 ? 'bg-dash-secondary' : 'bg-dash-primary';
}
